var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPedivanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118.095,
    height: 20.787,
    viewBox: "0 0 118.095 20.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_606",
    "data-name": "Rettangolo 606",
    width: 118.095,
    height: 20.787,
    transform: "translate(0 0)",
    fill: "#de9828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#188a8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#279b90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5fdc8e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1",
    "data-name": "Raggruppa 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_401",
    "data-name": "Tracciato 401",
    d: "M16.1,6.117a6.523,6.523,0,0,1-2.4,5.359,10.225,10.225,0,0,1-6.62,1.947H5.862L4.319,20.786H0L4.375.085H9.162a7.761,7.761,0,0,1,5.182,1.508A5.635,5.635,0,0,1,16.1,6.117M6.641,9.827h.793A4.739,4.739,0,0,0,10.6,8.849,3.255,3.255,0,0,0,11.753,6.23q0-2.548-2.761-2.549H7.944Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_402",
    "data-name": "Tracciato 402",
    d: "M28.391,20.787H16.822L21.2.085H32.781l-.765,3.6h-7.25l-.949,4.545h6.755l-.779,3.6H23.038l-1.132,5.337h7.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_403",
    "data-name": "Tracciato 403",
    d: "M50.523,7.916a15.893,15.893,0,0,1-1.388,6.889,9.925,9.925,0,0,1-4.014,4.453,12.1,12.1,0,0,1-6.195,1.529H32.54L36.915.085h5.607A8.148,8.148,0,0,1,48.435,2.11a7.717,7.717,0,0,1,2.088,5.806m-11.4,9.246a6.266,6.266,0,0,0,3.653-1.076,7.039,7.039,0,0,0,2.435-3.165,12.223,12.223,0,0,0,.878-4.778,4.8,4.8,0,0,0-1.027-3.321,3.767,3.767,0,0,0-2.952-1.14H40.483l-2.86,13.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_404",
    "data-name": "Tracciato 404",
    d: "M52.166,20.787,56.584.085H60.9l-4.418,20.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_405",
    "data-name": "Tracciato 405",
    d: "M68.323,16.553a40.778,40.778,0,0,1,1.557-4.007L76,.085h4.475L69.88,20.787H65.151l-1.8-20.7H67.53l.721,12.461q.057.638.057,1.884-.028,1.456-.084,2.123Zm21.452-.694h-6.7l-2.435,4.928H76.111L86.957,0H92.24l2.081,20.787H90.115Zm-.212-3.681-.368-4.956q-.141-1.854-.142-3.583v-.51a39.146,39.146,0,0,1-1.544,3.6l-2.662,5.451Zm24.157,8.609h-4.843L103.836,5.126h-.085l-.056.453q-.455,3.06-.935,5.466l-2.054,9.742H96.813l4.376-20.7h5.054l4.815,15.251h.057q.169-1.077.552-3.073T114.216.085H118.1Z",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedivanLogo);
export default __webpack_public_path__ + "static/media/PedivanLogo.7035531398a1daa9d7231ddaf4d2eb16.svg";
export { ForwardRef as ReactComponent };